import { Activity, Server, Wifi, TrendingUp } from 'lucide-react'

export default function StatusBar() {
  return (
    <div className="bg-aith-panel border-b border-aith-border px-6 py-2 flex items-center gap-8 text-[11px]">
      <div className="flex items-center gap-2">
        <Activity className="w-3.5 h-3.5 text-aith-green" />
        <span className="text-gray-300">Stomach: <span className="text-aith-green font-semibold">ONLINE</span></span>
      </div>
      <div className="flex items-center gap-2">
        <Server className="w-3.5 h-3.5 text-aith-green" />
        <span className="text-gray-300">Containers: <span className="text-aith-green font-semibold">3/4</span></span>
      </div>
      <div className="flex items-center gap-2">
        <Wifi className="w-3.5 h-3.5 text-aith-green" />
        <span className="text-gray-300">Tailscale: <span className="text-aith-green font-semibold">CONNECTED</span></span>
      </div>
      <div className="flex items-center gap-2">
        <TrendingUp className="w-3.5 h-3.5 text-aith-yellow" />
        <span className="text-gray-300">Revenue: <span className="text-aith-yellow font-semibold">$0.00 / $100.00</span></span>
      </div>
      <div className="ml-auto text-gray-500">UTC+07:00 | Bangkok</div>
    </div>
  )
}
